import { boot } from 'quasar/wrappers'
import VueOzoneUtils from '@Protium/vue-ozone-utils'

// FIXME path ./dist/style needs to be exported from package
import '@Protium/vue-ozone-utils/dist/style.scss'

export default boot(({ app }) => {
  app.use(VueOzoneUtils)
})
